import { Box, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Color, FontStyle, JobDisplays } from "../../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
} from "../../../utils/jobUtils";
import {
  ResourceBody,
  ResourceContainer,
  ResourceHeader,
} from "../ResourcePanel";

const resource1 = [
  [
    "li-1",
    () => (
      <span>
        <b>Keep your profile updated: </b>LinkedIn is your professional landing
        page, and it's likely the first thing a potential employer, hiring
        manager, or recruiter will see. As such, it's important to keep your
        profile up-to-date, even if you're not actively looking for a new role.
        This will allow you to maintain a solid presence and develop
        relationships over time that can make the search for your next
        opportunity practically seamless.
      </span>
    ),
  ],
  [
    "li-2",
    () => (
      <span>
        <b>Provide detail: </b>It's important to provide as much relevant
        information as possible on your LinkedIn profile, including your skills,
        accomplishments, and career path. Recruiters and companies will only
        look at and search for the relevant information they want, so don't be
        afraid to go overboard with the details.
      </span>
    ),
  ],
  [
    "li-3",
    () => (
      <span>
        <b>Engage regularly: </b>While you don't have to be a content creator to
        have a good LinkedIn profile, it's important to engage with the platform
        semi-regularly. This can involve posting updates, commenting on others'
        posts, or sharing articles related to your industry. Regular engagement
        will give your profile life and visibility, and it can help you grow
        your network over time.
      </span>
    ),
  ],
  [
    "li-4",
    () => (
      <span>
        <b>Craft your brand: </b>Your LinkedIn profile is a great place to
        showcase your brand and personality as a professional and human being.
        Take the time to summarize what you're all about and craft a clear and
        concise impact statement that highlights your accomplishments and career
        trajectory. This will allow others to keep you in mind when they have
        their next opening, even if you're not actively looking for a new role.
      </span>
    ),
  ],
  [
    "li-5",
    () => (
      <span>
        <b>Quantify your impact: </b>It's always a good idea to quantify your
        impact and give details about your accomplishments, regardless of how
        long you've been at a certain company. This will help you stand out from
        other candidates and demonstrate your value to potential employers.
      </span>
    ),
  ],
  [
    "li-6",
    () => (
      <span>
        <b>Be authentic: </b>While it's important to craft your brand and
        showcase your accomplishments, it's also important to be authentic and
        approachable on LinkedIn. Share your interests, passions, and hobbies to
        give others a snapshot of who you are not just professionally, but
        personally. This can help you build relationships and make connections
        that can benefit you in the long run.
      </span>
    ),
  ],
  ["x-div", ""],
  [
    "div",
    "Craft a LinkedIn profile that highlights your strengths and distinguishes you from other applicants. Remember, LinkedIn is your inbound funnel, and a little effort at first can save you time in the long run.",
  ],
];

const resourceDescription = {
  showIdx: 0,
  lastElementShown: () => (
    <span>
      <b>Keep your profile updated: </b>LinkedIn is your professional landing
      page, and it's likely the first thing a potential employer, hiring
      manager, or recruiter will see. As such, it's important to keep your
      profile up-to-date, even if you're not actively looking for a new role.
      This will allow you to maintain a solid presence and develop
      relationships...
    </span>
  ),
  list: [...resource1],
};

const LinkedinResource = ({
  job,
  fullHeight = false,
  showDescriptionOverlay,
}) => {
  const [showMore, setShowMore] = React.useState(false);
  // if (!job) return null;
  return (
    <ResourceContainer
      fullHeight={fullHeight}
      showDescriptionOverlay={showDescriptionOverlay}>
      <ResourceHeader
        title="Maximizing Your Career Opportunities: How to Create a Standout LinkedIn Profile"
        subtitle="By former Meta, Google, and Uber Recruiters at Fetti"
      />
      <ResourceBody data={resourceDescription} />
      {/* Bottom row with url + apply button */}
      {/* <Box sx={{ ...jobButtonStyle, width: "100%", maxWidth: "100%" }}>
        <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
          Download Our Free Resume Template
        </DownloadTemplateWrapper>
      </Box> */}
    </ResourceContainer>
  );
};

export default LinkedinResource;
